module.exports = __webpack_public_path__ + "img/about-us-logo.4fc467da.png";